import React, { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { XIcon, CheckCircle2Icon } from "lucide-react";
import { buyers, MOCKUP_IMAGE } from "../data/content";
const FIRST_DELAY = 6000;
const INTERVAL = 13000;
const VISIBLE_FOR = 5000;
export function PurchasePopup() {
  const [index, setIndex] = useState(0);
  const [show, setShow] = useState(false);
  useEffect(() => {
    let hideTimer: number | undefined;
    const showNext = () => {
      setIndex(Math.floor(Math.random() * buyers.length));
      setShow(true);
      window.clearTimeout(hideTimer);
      hideTimer = window.setTimeout(() => setShow(false), VISIBLE_FOR);
    };
    const first = window.setTimeout(showNext, FIRST_DELAY);
    const interval = window.setInterval(showNext, INTERVAL);
    return () => {
      window.clearTimeout(first);
      window.clearTimeout(hideTimer);
      window.clearInterval(interval);
    };
  }, []);
  const buyer = buyers[index];
  return <div className="pointer-events-none fixed inset-x-3 bottom-[92px] z-50 sm:inset-x-auto sm:bottom-5 sm:left-5 sm:w-[360px]" aria-live="polite" data-id="element-63" data-mp="165pjw8a9imau">
      <AnimatePresence data-id="element-64" data-mp="116czdu6v5rbf">
        {show && <motion.div key={`${buyer.name}-${index}`} initial={{
        opacity: 0,
        y: 16,
        scale: 0.96
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 16,
        scale: 0.96
      }} transition={{
        duration: 0.22,
        ease: [0.23, 1, 0.32, 1]
      }} className="pointer-events-auto relative flex items-center gap-3 rounded-2xl bg-white p-3 pr-9 shadow-2xl shadow-navy-950/30 ring-1 ring-navy-900/10" data-id="element-65" data-mp="1fviwncm557go">
            <img src={MOCKUP_IMAGE} alt="" className="h-14 w-14 shrink-0 rounded-xl bg-paper object-cover" data-id="element-66" data-mp="x382q89gsjup" />
            <div className="min-w-0 text-sm text-ink" data-id="element-67" data-mp="s8khqjdo67kv">
              <p className="leading-snug" data-id="element-68" data-mp="28j4zginjo82h">
                <strong data-id="element-69" data-mp="23ld9vvadgy1g">{buyer.name}</strong> from <strong data-id="element-70" data-mp="23m6642bpg55c">{buyer.country}</strong> just purchased the{" "}
                <span className="font-semibold text-electric" data-id="element-71" data-mp="2aol3ga6w861o">Aesthetic Laser Clinical Blueprint™</span>
              </p>
              <p className="mt-0.5 flex items-center gap-1 text-xs text-muted" data-id="element-72" data-mp="2fmv2ivvqnqsk">
                <CheckCircle2Icon className="h-3.5 w-3.5 text-success" aria-hidden="true" data-id="element-73" data-mp="2kn0n5s3lcd15" />
                {buyer.minutesAgo} {buyer.minutesAgo === 1 ? "minute" : "minutes"} ago
              </p>
            </div>
            <button type="button" onClick={() => setShow(false)} className="absolute right-2 top-2 rounded-full p-1 text-muted transition-colors duration-150 hover:bg-paper hover:text-ink" aria-label="Close notification" data-id="element-74" data-mp="1ryljg1pwth54">
              <XIcon className="h-4 w-4" data-id="element-75" data-mp="26mpxuthxj6i3" />
            </button>
          </motion.div>}
      </AnimatePresence>
    </div>;
}